<template>
  <el-dialog
    custom-class="choose"
    top="0"
    :visible.sync="isVisible"
    :before-close="chooseDialogClose"
    :show-close="ifAddFlag"
  >
    <div v-if="ifAddFlag" slot="title" class="dialog-title">
      <div class="bold t1">添加教材</div>
      <div class="gray t2">选择教材信息</div>
    </div>
    <div v-else slot="title" class="dialog-title">
      <div class="bold t1">越了解越贴心</div>
      <div class="gray t2">选择课本信息</div>
    </div>
    <div class="type clearfix" v-if="xdxkList.length && !isSchoolBased">
      <div class="tip" v-if="!xd">
        <i class="iconfont icon-fuhao1"></i>
        请选择学段
      </div>
      <span class="gray lb left">学段:</span>
      <el-radio-group v-model="xd" size="mini" @change="changeXd">
        <el-radio
          v-for="item in xdxkList"
          :key="item.id"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="type clearfix" v-if="xkList.length && !isSchoolBased">
      <div class="tip" v-if="xd && !xk">
        <i class="iconfont icon-fuhao1"></i>
        请选择学科
      </div>
      <span class="gray lb left">学科:</span>
      <el-radio-group
        :disabled="!!this.disable[0]"
        v-model="xk"
        size="mini"
        @change="changeXk"
      >
        <el-radio
          v-for="item in xkList"
          :key="item.id"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="type clearfix" v-if="bbList.length">
      <div class="tip" v-if="xd && xk && !bb">
        <i class="iconfont icon-fuhao1"></i>
        请选择版本
      </div>
      <span class="gray lb left">版本:</span>
      <el-radio-group
        :disabled="!!this.disable[1]"
        v-model="bb"
        size="mini"
        @change="changeBb"
      >
        <el-radio
          v-for="item in bbList"
          :key="item.id"
          :label="item.id"
          border
          >{{ item.name }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="type clearfix" v-if="textbooks.length">
      <div class="tip" v-if="xd && xk && bb && !cb">
        <i class="iconfont icon-fuhao1"></i>
        请选择册别
      </div>
      <span class="gray lb left">册别:</span>
      <el-radio-group
        :disabled="!!this.disable[2]"
        v-model="cb"
        size="mini"
        @change="changeCb"
      >
        <el-radio
          v-for="item in textbooks"
          :key="item.id"
          :label="item.id"
          :disabled="item.disabled"
          border
          >{{ item.volume }}</el-radio
        >
      </el-radio-group>
    </div>
    <div class="alarm" v-if="(!xd || !xk || !bb || !cb) && !isSchoolBased">
      提示：课本信息由学段、学科、版本、册别组合而成，设置课本信息后，你会得到专属的服务体验。
    </div>
    <div slot="footer" class="dialog-footer">
      <!-- <button v-if="ifAddFlag" data-io-click="tracker"  @click="chooseDialogClose" class="cb">
        取消
      </button> -->
      <button
        v-if="xd && xk && bb && cb"
        data-io-click="tracker"  @click="submitData"
        :class="['sb', { active: isAbleTosubmit }]"
      >
        确认
      </button>
    </div>
  </el-dialog>
</template>
<script>
import { Message } from "element-ui";
import tracker from "@/assets/js/statistics/xkw.tracker";
import {
  getTextbooks,
  getVersions,
  getStages,
  addTextbook,
} from "@/utils/apis";
export default {
  name: "chooseDialog",
  components: {},
  props: {
    chooseDialogFlag: {
      type: Boolean,
      default: false,
    },
    // 用户已经选过的教材
    userTextbooks: {
      type: Array,
      default() {
        return [];
      },
    },
    // 学科、学段选择范围
    textbookScope: {
      type: Object,
      default() {
        return {};
      },
    },
    // 是否是校本
    isSchoolBased: {
      type: Boolean,
      default: false,
    },
    triggerType: {
      type: String,
      default: "主动",
    },
  },
  mounted() {
    // this.init();
  },
  data() {
    return {
      isAbleTosubmit: false, //是否可以提交了
      disable: [1, 1, 1],
      xdxkList: [],
      xkList: [],
      bbList: [],
      textbooks: [],
      xd: 0,
      xk: this.textbookScope.subjectId || 0,
      bb: 0,
      cb: 0,
    };
  },
  watch: {
    chooseDialogFlag: {
      async handler(newValue, old) {
        if (newValue) {
          this.init();
        }
        if (this.isSchoolBased) {
          this.xd = this.textbookScope.stageId || this.xdxkList[0]["id"];
          this.xd && (await this.changeXd(this.xd));
          this.xk = this.textbookScope.subjectId || 0;
          this.xk && this.changeXk(this.xk);
        }
      },
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.chooseDialogFlag;
      },
      set() {},
    },
    ifAddFlag: {
      get() {
        return !!this.userTextbooks.length;
      },
      set() {},
    },
  },
  methods: {
    async init() {
      // if (this.isSchoolBased) {
      //   this.disable = [1, 0, 1];
      // }
      console.log("init");
      const data1 = await getStages();
      this.xdxkList = data1.result;
      this.xkList = this.xdxkList[0]["subjectList"];
      let xd = this.textbookScope.stageId || this.xdxkList[0]["id"];
      const xk = this.xdxkList[0]["subjectList"][0]["id"];
      const data2 = await getVersions({
        stageId: xd,
        subjectId: xk,
      });
      this.bbList = data2.result;
      const bb = this.bbList[0]["id"];
      this.getTextbooks({ versionId: bb });
    },
    async submitData() {
      if (this.isAbleTosubmit) {
        console.log("提交");
        this.$parent.loading = true;
        const res = await addTextbook({ textbookId: this.cb });
        // 修改当前课程以及修改
        if (res.code === 200) {
          this.$emit("submitSuccess", this.cb, {
            stageId: this.xd,
            subjectId: this.xk,
            versionId: this.bb,
          });
          this.sendTongjiData("提交成功");
          this.chooseDialogClose();
          Message({
            message: "添加教材成功！",
            type: "success",
            duration: 3 * 1000,
          });
        }
      } else {
        Message({
          message: "请向下滚动选择完毕",
          type: "error",
          duration: 3 * 1000,
        });
      }
    },
    //点击学段
    async changeXd(id) {
      this.disable = [0, 1, 1];
      const data = this.xdxkList.filter((item) => {
        return item.id === id;
      });
      this.xkList = data[0].subjectList;
      this.xk = 0;
      this.bb = 0;
      this.cb = 0;
      const xk = this.xdxkList[0]["subjectList"][0]["id"];
      const data2 = await getVersions({
        stageId: this.xd,
        subjectId: xk,
      });
      this.bbList = data2.result;
      const bb = this.bbList[0]["id"];
      this.getTextbooks({ versionId: bb });
      this.isAbleTosubmit = false;
    },
    //点击学科
    async changeXk(id) {
      this.disable = [0, 0, 1];
      const data = await getVersions({
        stageId: this.xd,
        subjectId: id,
      });
      this.bb = 0;
      this.cb = 0;
      if (data.code && data.result.length) {
        this.bbList = data.result;
        const bb = this.bbList[0]["id"];
        this.getTextbooks({ versionId: bb });
      } else {
        this.bbList = [];
        this.textbooks = [];
      }
      this.isAbleTosubmit = false;
    },
    // 获取册别
    async getTextbooks(param) {
      const data = await getTextbooks(param);
      if (data.code === 200) {
        data.result.forEach((book) => {
          // 用户是否已经添加过
          this.userTextbooks.forEach((userBook) => {
            if (book.id === userBook.bookId) {
              book.disabled = true;
            }
          });
        });
        this.textbooks = data.result;
      }
    },
    changeCb(id) {
      if (id) {
        this.isAbleTosubmit = true;
      }
    },
    //点击版本
    async changeBb(id) {
      this.disable = [0, 0, 0];
      await this.getTextbooks({ versionId: id });
      this.cb = 0;
      this.isAbleTosubmit = false;
      // if (this.textbooks && this.textbooks.length) {
      //   this.isAbleTosubmit = false;
      // } else {
      //   this.isAbleTosubmit = true;
      // }
    },
    sendTongjiData(type) {
      let banben = this.bbList.find((item) => item.id === this.bb);
      banben = banben ? banben.name : "";
      let xueke = this.xkList.find((item) => item.id === this.xk);
      xueke = xueke ? xueke.name : "";
      let xueduan = this.xdxkList.find((item) => item.id === this.xd);
      xueduan = xueduan ? xueduan.name : "";
      let cebie = this.textbooks.find((item) => item.id === this.cb);
      cebie = cebie ? cebie.volume : "";
      // console.log("triggerType", this.triggerType);
      tracker.handleSendTongji({
        $event_name: "set_textbook_course_popup",
        operate_type: type,
        popup_name: "教材设置",
        trigger_type: this.triggerType,
        xueduan,
        xueke,
        banben,
        cebie,
      });
    },
    chooseDialogClose() {
      this.sendTongjiData("关闭");
      this.xd = 0;
      this.xk = 0;
      this.bb = 0;
      this.cb = 0;
      this.disable = [1, 1, 1];
      // if (this.isSchoolBased) {
      //   this.disable = [1, 0, 1];
      // }
      this.isAbleTosubmit = false;
      this.$emit("close");
      // this.$emit("update:chooseDialogFlag", false);
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .choose {
  width: 708px;
  max-height: 80%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  // height: 620px;
  .el-dialog__header {
    padding: 0;
    border-bottom: none !important;
    height: auto;
  }
  .dialog-title {
    text-align: center;
    padding: 28px 0 10px;
    .t1 {
      line-height: 20px;
      height: 20px;
      font-weight: 600;
      font-size: 20px;
      color: #333;
    }
    .t2 {
      margin-top: 14px;
      line-height: 14px;
      font-size: 14px;
    }
  }
  .el-dialog__body {
    padding-left: 29px;
    padding-top: 36px;
    // height: 446px;
    // overflow: auto;
    .type {
      margin-bottom: 18px;
      display: block;
      position: relative;
      .tip {
        display: inline-block;
        position: absolute;
        background: #0057ff;
        border-radius: 8px;
        height: 20px;
        top: -29px;
        line-height: 20px;
        padding: 0 14px 0 6px;
        font-size: 12px;
        color: #fff;
        left: 0;
        i {
          font-size: 7px;
          color: #4de3f8;
          transform: scale(0.9);
        }
        &::after {
          position: absolute;
          content: "";
          width: 0px;
          height: 0px;
          border-width: 5px;
          border-style: solid;
          border-color: #0057ff transparent transparent transparent;
          bottom: -9px;
          left: 10px;
        }
      }
    }
    .type * {
      font-size: 14px;
    }
    .lb {
      margin-right: 14px;
      line-height: 28px;
    }
    .alarm {
      font-size: 14px;
      text-align: center;
      margin-top: 47px;
    }
  }
  .el-radio-group {
    float: left;
    width: 600px;
  }
  .el-radio {
    margin-right: 14px;
    // background: #eff1f4;
  }
  .dialog-footer {
    text-align: center;
    button {
      box-sizing: border-box;
      width: 132px;
      height: 42px;
      border: none;
      border-radius: 21px;
      border: 1px solid;
      cursor: pointer;
      font-size: 14px;
    }
    .sb {
      background: #7f848b;
      border-color: #7f848b;
      color: #fff;
    }
    .sb.active {
      background: #0057ff;
      border-color: #0057ff;
      color: #fff;
    }
    .cb {
      color: #7f848b;
      border-color: #7f848b;
      background: #fff;
      margin-right: 40px;
    }
  }
  .el-radio__inner,
  .el-radio__input,
  .el-radio__original {
    display: none;
  }
  .el-radio__label {
    padding-left: 0;
  }
  .el-radio--mini.is-bordered {
    padding: 6px 15px 0 15px;
    border-radius: 25px;
    margin-left: 0;
    border: none;
    margin-bottom: 16px;
  }
  .el-radio--mini.is-bordered.is-checked {
    border: 1px solid #0057ff;
  }
  .el-radio.is-bordered.is-checked {
    background-color: #e5f7fe;
    border-color: #0057ff;
    color: #0057ff;
  }
  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
  .el-dialog__footer {
    // position: absolute;
    // width: 100%;
    // bottom: 3px;
  }
}
</style>
